import orderstpl from './orders.tpl.html';

export class Orders {

}

export const orders = {
  template: orderstpl,
  controller: Orders,
};
